import { Modal, Button, Spin } from "antd";
import { useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import "../../../styles/teamMember.scss";
import { useSelector } from "react-redux";
import {
  CREATING_EMPLOYMENT_TYPE,
  CREATING_MEMBER_POSITION,
  CREATING_MEMBER_AWARD,
} from "../../../store/team-member-store/reducer";
import FormEmployType from "./formEmployType";
import FormPosition from "./formPosition";
import FormAward from "./formAward";

const ModalFleetVehicles = ({
  form,
  fetchSubData,
  isModalVisible,
  setIsModalVisible,
}) => {
  const [loading, setLoading] = useState(false);
  const { organisationId } = useSelector(({ auth }) => auth.user);

  const [mbEmploy, semMbEmploy] = useState({
    organisationId: organisationId,
    _id: "new",
    active: true,
  });
  const [position, setPosition] = useState({
    organisationId: organisationId,
    _id: "new",
    active: true,
  });

  const [award, setAward] = useState({
    organisationId: organisationId,
    _id: "new",
    active: true,
  });

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 18, color: "#fff" }} spin />
  );

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleOk = () => {
    setLoading(true);
    switch (isModalVisible.type) {
      case "Employment Type":
        CREATING_EMPLOYMENT_TYPE(mbEmploy).then((data) => {
          fetchSubData();
          setTimeout(() => {
            form.setFields([
              {
                name: "employmentTypeId",
                value: data?._id,
              },
            ]);
            setLoading(false);
            setIsModalVisible(false);
          }, 1000);
        });
        break;
      case "Position":
        CREATING_MEMBER_POSITION(position).then((data) => {
          fetchSubData();
          setTimeout(() => {
            form.setFields([
              {
                name: "positionId",
                value: data?._id,
              },
            ]);
            setLoading(false);
            setIsModalVisible(false);
          }, 1500);
        });
        break;
      case "Award":
        CREATING_MEMBER_AWARD(award).then((data) => {
          fetchSubData();
          setTimeout(() => {
            form.setFields([
              {
                name: "employeeAwardId",
                value: data?._id,
              },
            ]);
            setLoading(false);
            setIsModalVisible(false);
          }, 1500);
        });
        break;
      default:
        setLoading(false);
        break;
    }
  };

  const renderType = () => {
    switch (isModalVisible.type) {
      case "Employment Type":
        return <FormEmployType mbEmploy={mbEmploy} semMbEmploy={semMbEmploy} />;
      case "Position":
        return <FormPosition position={position} setPosition={setPosition} />;
      case "Award":
        return <FormAward award={award} setAward={setAward} />;
      default:
        setLoading(false);
        break;
    }
  };

  return (
    <Modal
      title={"Add " + isModalVisible.type}
      visible={isModalVisible}
      onCancel={handleCancel}
      className="modal-sub"
      okText="Add"
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button
          key="add"
          type="primary"
          onClick={handleOk}
          style={{ opacity: loading && 0.6 }}
        >
          {loading ? <Spin indicator={antIcon} /> : "Add"}
        </Button>,
      ]}
    >
      {renderType()}
    </Modal>
  );
};

export default ModalFleetVehicles;
